"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implementation of a connection summary.
 * This does not follow the Impl pattern as it is just a property bag.
 */
class ConnectionSummary {
    constructor(_connectionInfo) {
        this._connectionInfo = _connectionInfo;
    }
    get name() {
        return this._connectionInfo.name;
    }
    get id() {
        return this._connectionInfo.id;
    }
    get serverURI() {
        return this._connectionInfo.serverURI;
    }
    get type() {
        return this._connectionInfo.type;
    }
}
exports.ConnectionSummary = ConnectionSummary;
//# sourceMappingURL=ConnectionSummary.js.map